import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16616196"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-area__overlay" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "dt-icon",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14,12H19.5L14,6.5V12M8,5H15L21,11V21A2,2 0 0,1 19,23H8C6.89,23 6,22.1 6,21V18H11V20L15,17L11,14V16H6V7A2,2 0 0,1 8,5M13.5,3H4V16H6V18H4A2,2 0 0,1 2,16V3A2,2 0 0,1 4,1H11.5L13.5,3Z" })
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "video-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M17,10.5L21,6.5V17.5L17,13.5V17A1,1 0 0,1 16,18H4A1,1 0 0,1 3,17V7A1,1 0 0,1 4,6H16A1,1 0 0,1 17,7V10.5M10.91,9.55L9.2,11.82L10.5,13.55L9.77,14.09L7.73,11.36L5,15H15L10.91,9.55Z" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = {
  class: "drag-drop-input-label",
  href: "#"
}
const _hoisted_8 = { class: "accepted-files" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["drop-area", { active :  _ctx.dropZoneHovered }]),
      id: "drop-area",
      ref: "dropArea",
      onDragenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragEnterHandler($event))),
      onDragleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragLeaveHandler($event))),
      onDragover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragOverHandler($event))),
      onDrop: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dropHandler($event)))
    }, [
      _hoisted_1,
      (_ctx.isUploadingVideo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_ctx.mediaLayoutPreviewURL)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "preview-image",
              style: _normalizeStyle(`max-height:${_ctx.maxHeightOverride}`),
              src: _ctx.mediaLayoutPreviewURL
            }, null, 12, _hoisted_5))
          : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("em", null, [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode("Browse files"),
                _createElementVNode("input", {
                  type: "file",
                  id: "fileInput",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newFileHandler($event.target.files[0])))
                }, null, 32)
              ])
            ]),
            _: 1
          }),
          _createTextVNode(" or drag-and-drop here to replace media ")
        ])
      ]),
      _createElementVNode("span", _hoisted_8, "Accepted file types: PNG, JPEG, " + _toDisplayString(_ctx.allowVideo === 'true' ? 'JPG and MP4' : 'and JPG'), 1)
    ], 34)
  ]))
}